import { useMutation, useQueryClient } from '@tanstack/react-query';
import { QUERY_KEYS } from './queries';
import { getNativeWebview } from '../react-queries/queries';
import { saveConf } from '../api/native/NativeApis';

// 스케줄 생성 타입
export interface CreateScheduleInput {
  icon: 'nudok' | 'nupil' | 'moim';
  title: string;
  period: string;
  dDay: number;
}

// 스케줄 생성 함수
const createSchedule = async (input: CreateScheduleInput) => {
  // 실제 API 호출 대신 목업 데이터 반환
  return new Promise((resolve) => {
    setTimeout(() => {
      resolve({
        id: Date.now().toString(),
        ...input,
      });
    }, 500);
  });
};

// 스케줄 삭제 함수
const deleteSchedule = async (id: string) => {
  // 실제 API 호출 대신 목업 데이터 반환
  return new Promise((resolve) => {
    setTimeout(() => {
      resolve({ id });
    }, 500);
  });
};

// 선택된 날짜 업데이트 함수
const updateSelectedDate = async (date: Date) => {
  localStorage.setItem(QUERY_KEYS.SELECTED_DATE, date.toISOString());
  return date;
};

// 커스텀 훅: 스케줄 생성
export const useCreateScheduleMutation = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: createSchedule,
    onSuccess: () => {
      // 스케줄 목록 캐시 무효화
      queryClient.invalidateQueries({ queryKey: [QUERY_KEYS.SCHEDULES] });
    },
  });
};

// 커스텀 훅: 스케줄 삭제
export const useDeleteScheduleMutation = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: deleteSchedule,
    onSuccess: () => {
      // 스케줄 목록 캐시 무효화
      queryClient.invalidateQueries({ queryKey: [QUERY_KEYS.SCHEDULES] });
    },
  });
};

// 커스텀 훅: 선택된 날짜 업데이트
export const useUpdateSelectedDateMutation = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: updateSelectedDate,
    onSuccess: (date) => {
      // 선택된 날짜 캐시 업데이트
      queryClient.setQueryData([QUERY_KEYS.SELECTED_DATE], date);
    },
  });
};


export const useLogoutMutation = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async () => {
      localStorage.removeItem('accessToken');
      localStorage.removeItem('refreshToken');
      try {
        if(getNativeWebview()){
          saveConf({accessToken:"", refreshToken:""});
        }
      } catch (error) {
        console.error('로그아웃 실패:', error);
      }
      queryClient.invalidateQueries({ queryKey: [QUERY_KEYS.LOGIN] });
      queryClient.invalidateQueries({ queryKey: [QUERY_KEYS.UNREAD_MESSAGE_COUNT] });
    },
  });
};